module.exports = __webpack_public_path__ + "img/engineer_fbs_samurai_01.27a714d1.png";